import type { FC } from 'react';
import Image from 'next/image';
import { Box } from '@eqi-investimentos/react';

export const PDFPage: FC<PDFPageProps> = ({ page }) => (
  <Box position="relative" w="full" h={520}>
    <Image src={page} alt="" fill style={{ objectFit: 'contain' }} />
  </Box>
);

type PDFPageProps = {
  page: string;
};
